import type {Locale} from '.';

const localeValues: Locale = {
    locale: 'en',
    PageContainer: {
        back: 'Back',
        detail: 'Learn details'
    },
    PageLayout: {
        back: 'Back'
    },
    EmptyStatus: {
        noResult: 'No results yet',
        noAccessPermissions: 'No access permissions',
        // eslint-disable-next-line max-len
        connectAdministrator: 'If you need access permission for this page, please contact the administrator for configuration',
        replaceKeywords: 'Please try changing the keywords',
        pageNotFound: 'Page not found',
        pageDoesNotExist: 'The page you are trying to access does not exist.',
        refreshPage: 'Refresh page',
        serverError: 'Server error',
        serverErrorNoResponse: 'Server error Unable to respond.',
        returnHome: 'Return to Home.',
        problemStillExists: 'If the problem persists, please contact the administrator',
        please: 'Please',
        againLater: 'Please try again later',
        or: 'Or'
    },
    Status: {
        running: 'Running',
        warning: 'Warning',
        success: 'Success',
        error: 'Error',
        unavailable: 'Unavailable'
    },
    FileUpload: {
        uploadFailed: 'Upload failed',
        updateCompleted: 'Updated successfully',
        noticeCopywriting: 'Note: Please adjust the file name before uploading so others can identify it'
    },
    Loading: {
        Loading: 'Loading...'
    },
    useForm: {
        prev: 'Previous step',
        next: 'Next step',
        submit: 'Confirm'
    },
    useList: {
        loadingData: 'Data is loading...',
        noData: 'No data yet',
        total: 'Total',
        stripData: 'Entries of data'
    },
    useTable: {
        confirm: 'Confirm',
        requestFailedPleaseCheck: 'Request failed. Please check',
        total: 'Total ',
        stripData: ' items',
        failedToGetRecords: 'Failed to retrieve records'
    },
    HooksList: {
        chosen: 'Selected',
        Record: 'records',
        startingTime: 'Start time',
        endTime: 'End time',
        startDate: 'Start date',
        endData: 'End date'
    },
    HooksTable: {
        sure: 'Confirm',
        cancel: 'Cancel',
        submitting: 'Submitting...',
        noResult: 'No results yet',
        noData: 'No data yet',
        no: 'You have not yet',
        any: 'any ',
        create: 'Create ',
        new: 'New',
        selected: 'Selected',
        item: 'items. ',
        item2: 'items.',
        total: 'Total'
    },
    HooksForm: {
        advanced: 'Advanced settings'
    },
    useDialog: {
        sure: 'Confirm',
        cancel: 'Cancel',
        submitting: 'Submitting...'
    }
};

export default localeValues;